import { render } from "./index.vue?vue&type=template&id=a04cf5ec&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=a04cf5ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a04cf5ec"

export default script